"use strict";

require("core-js/modules/es.string.trim");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _validator = _interopRequireDefault(require("validator"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isEmail = function isEmail(message) {
  return function (_ref) {
    var field = _ref.field;

    if (!field.value) {
      return true;
    }

    var isValid = _validator.default.isEmail(field.value.trim());

    return [isValid, message || 'Please enter a valid email address'];
  };
};

var _default = isEmail;
exports.default = _default;
//# sourceMappingURL=isEmail.js.map